import Swiper from 'swiper';

const sliderInit = () => {
	const moreCategoriesSlider = document.querySelector('.more-categories__categories-swiper');
	const moreSitesSlider = document.querySelector('.more-sites__sites-swiper');
	const firstSitesSlider = document.querySelector('.home-main__first-sites-swiper');
	const secondSitesSlider = document.querySelector('.home-main__second-sites-swiper');

	const moreSitesSwiper = new Swiper(moreSitesSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
	});

	const moreCategoriesSwiper = new Swiper(moreCategoriesSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
	});

	const firstSitesSwiper = new Swiper(firstSitesSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
	});

	const secondSitesSwiper = new Swiper(secondSitesSlider, {
		speed: 500,
		spaceBetween: 0,
		slidesPerView: 'auto',
	});
};

export default sliderInit;
